import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { SelectNodeSubject } from './tree-view.type'

@Injectable({ providedIn: 'root' })
export class TreeViewService {
  public closeAllNodes$ = new Subject<number>()
  public selectNode$ = new Subject<SelectNodeSubject | null>()
  public openChildren$ = new Subject<string>()
}
